import * as React from 'react';
import { AppServices } from '../../AppServices';

// ===============================================================================

export enum ToxnotReactStatusComponentState {
    Normal,
    BeginOperation,
    OperationSucceeded,
    OperationFailed
}

// ===============================================================================

interface ToxnotReactStatusComponentProps {
    appServices: AppServices;
    state: ToxnotReactStatusComponentState;
    localizedOperationMessage?: string | JSX.Element;
}

// ===============================================================================
    
export class ToxnotReactStatusComponent extends React.PureComponent<ToxnotReactStatusComponentProps> {

    // ===============================================================================

    public render() {
        switch (this.props.state) {
            case ToxnotReactStatusComponentState.BeginOperation:
                return (
                    <div className="alert alert-info">{this.props.localizedOperationMessage ?? this.props.appServices.localizeString("Working on it...")}</div>
                );
            case ToxnotReactStatusComponentState.OperationSucceeded:
                return (
                    <div className="alert alert-success">{this.props.localizedOperationMessage ?? this.props.appServices.localizeString("Succeeded!")}</div>
                );
            case ToxnotReactStatusComponentState.OperationFailed:
                return (
                    <div className="alert alert-danger">{this.props.localizedOperationMessage ?? this.props.appServices.localizeString("Sorry, there was an issue accessing the service...")}</div>
                );
            default:
                return null;
        }
    }
}